import { Handle, Position, NodeProps } from '@xyflow/react';
import { FlowNodeTypeValue } from '../types';
import { getNodeInfo } from '../metadata';

interface ResolveTicketNodeData {
  type: FlowNodeTypeValue;
  config: string;
  [key: string]: unknown;
}

/**
 * Nó terminal "Encerrar atendimento". Aplica a categoria configurada e resolve o ticket.
 * Sem porta de saída — encerra a execução do fluxo.
 */
export function ResolveTicketNode({ data, selected }: NodeProps) {
  const d = data as ResolveTicketNodeData;
  const info = getNodeInfo(d.type);
  const preview = getMessage(d.config);

  return (
    <div
      className="wt-rf-node wt-rf-node-resolve"
      data-selected={selected ? 'true' : 'false'}
      style={{ borderColor: info.color }}
    >
      <Handle type="target" position={Position.Top} className="wt-rf-port" />
      <div className="wt-rf-node-head" style={{ color: info.color }}>
        <span className="wt-rf-node-dot" style={{ background: info.color }} />
        <span>{info.label}</span>
      </div>
      {preview && <div className="wt-rf-node-preview">{preview}</div>}
    </div>
  );
}

function getMessage(configJson: string): string {
  try {
    const cfg = JSON.parse(configJson || '{}');
    const v = cfg.message;
    if (typeof v === 'string' && v.length > 0) return v.length > 40 ? v.slice(0, 40) + '...' : v;
  } catch {
    /* fallthrough */
  }
  return '';
}
